import { exportToCSV } from "../../../core/common/GlobalFunctions/exportTableData";

export const handleDownloadSample = () => {
  const sampleData = [
    {
      employee_id: 3,
      net_salary: 588.3,
      start_date: "'2025-06-01",
      end_date: "'2025-06-30",
      overtime_pay_id: 0.0,
      earning_name: 'Basic',
      earning_amount: 871.0,
      earning_id: 16.0,
      earning_percent: '',
      deduction_name: 'PAYEE',
      deduction_amount: 34.79,
      deduction_id: 1,
      deduction_percent: '',
      pay_scale_id: 12,
    },
    {
      employee_id: 3,
      net_salary: 588.3,
      start_date: "'2025-06-01", 
      end_date: "'2025-06-30",
      overtime_pay_id: 0.0,
      earning_name: '',
      earning_amount: '',
      earning_id: '',
      earning_percent: '',
      deduction_name: 'SNNIT',
      deduction_amount: 47.91,
      deduction_id: 2,
      deduction_percent: 5.5,
      pay_scale_id: 12,
    },
  ];

  exportToCSV(sampleData, 'employee_salary_sample');
};
